const {
    BROKER_MOVEMENT_CANCELATION_OPEN_MODAL
} = require('constants/contactCenter/actionTypes')

const openMovementCancelationModal = (open) => ({
    type: BROKER_MOVEMENT_CANCELATION_OPEN_MODAL,
    payload: {
        open
    }
})

export {
    openMovementCancelationModal
}
